<template>
	<footer>
		<Menu />
		<Copyright />
	</footer>
</template>